import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  box-sizing: border-box;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
  box-sizing: border-box;
}
body {
  line-height: 1;
  font-family: 'Instrument Sans', sans-serif;
  font-size: 16px;
  background-color: ${(p) => p.theme.background};
  color: ${(p) => p.theme.text};
	line-height: 1.3;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
table {
  box-sizing: border-box;
  border-collapse: collapse;
  border-spacing: 0;
  background-color: ${(p) => p.theme.background};
  color: ${(p) => p.theme.text};
}

h1 {
  font-size: 2rem;
}
h2 {
  font-size: 1.5rem;
}
/* Works on Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: ${(p) => p.theme.accent} ${(p) => p.theme.background};
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 10px;
}

*::-webkit-scrollbar-track {
  background: ${(p) => p.theme.background};
}

*::-webkit-scrollbar-thumb {
  background-color: ${(p) => p.theme.accent};
  border-radius: 20px;
  border: 3px solid ${(p) => p.theme.background};
}
a {
	color: ${(p) => p.theme.accent}
}
`;

export default GlobalStyles;
